/**
 * 2FA is currently disabled. Redirect anyone who lands here back to login.
 */
import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

export default function Verify2FA() {
  const navigate = useNavigate()
  useEffect(() => {
    sessionStorage.removeItem('cg_pending_token')
    sessionStorage.removeItem('cg_2fa_method')
    navigate('/login', { replace: true })
  }, [])
  return null
}
